import { apiInterfaceForJson } from "../common/apiManager";

export const getRequisitionsForAccessioning = (filters) => {
    return apiInterfaceForJson("/order/v1/getRequisitionsForAccessioning", "POST", filters);
}